import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-65a4b335")

_pushScopeId("data-v-65a4b335")
const _hoisted_1 = { class: "responsive-flex" }
const _hoisted_2 = { style: {"flex-grow":"1"} }
const _hoisted_3 = { class: "transactions" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_f7_link = _resolveComponent("f7-link")
  const _component_f7_navbar = _resolveComponent("f7-navbar")
  const _component_PointsOverview = _resolveComponent("PointsOverview")
  const _component_SalespersonList = _resolveComponent("SalespersonList")
  const _component_TransactionsList = _resolveComponent("TransactionsList")
  const _component_f7_page = _resolveComponent("f7-page")

  return (_openBlock(), _createBlock(_component_f7_page, null, {
    default: _withId(() => [
      _createVNode(_component_f7_navbar, {
        title: "Rewards",
        subtitle: _ctx.rewardsStore.currentUser?.builderID
      }, {
        left: _withId(() => [
          _createVNode(_component_f7_link, {
            "icon-only": "",
            "icon-f7": "chevron_left",
            href: `/builders/${_ctx.rewardsStore.currentUser?.builderID}`
          }, null, 8, ["href"])
        ]),
        _: 1
      }, 8, ["subtitle"]),
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_PointsOverview),
          _createVNode(_component_SalespersonList)
        ]),
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_TransactionsList)
        ])
      ])
    ]),
    _: 1
  }))
})